const pageJobs = document.querySelector('.page-jobb-lead');

if (pageJobs) {
  const headerElement = document.getElementById('main-header');

  const headerHeight = window.getComputedStyle(headerElement).height;

  function pageJobsSetPadding() {
    let windowWidth = window.innerWidth;

    if (windowWidth > 768) {
      pageJobs.style.paddingTop = `calc(${headerHeight} + 6.25rem)`;
    } else {
      pageJobs.style.paddingTop = `calc(${headerHeight} + 4.5rem)`;
    }
  }

  pageJobsSetPadding();

  window.addEventListener('resize', pageJobsSetPadding);
}